import React, { type ReactElement } from "react";
import { Bell } from "lucide-react";
import { badgeLabel } from "../../lib/notifications-client";
import { railRowClass, type RenderRailLink } from "./always-rail-parts";
import { SiderailIcon, SiderailLabelClip, SiderailTooltip } from "./siderail-parts";

// The rail's Notifications row (NO-830). The unread count is informational,
// so it reads in the olive primary pill, never a danger tone, and it is
// hidden at zero. Screen readers hear "Notifications, 2 unread". A leaf
// module (`import React`, relative imports, no router, no queries) so
// `tsx --test` renders it; the composer supplies the link and the count.

const UNREAD_PILL =
  "ml-auto mr-2 inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1.5 font-sans text-caption font-bold text-primary-foreground";

export function RailNotificationsRow({
  unread,
  current,
  collapsed,
  renderLink,
}: {
  unread: number;
  current: boolean;
  collapsed: boolean;
  renderLink: RenderRailLink;
}): ReactElement {
  const badge = badgeLabel(unread);

  return (
    <SiderailTooltip label="Notifications" collapsed={collapsed}>
      {renderLink({
        href: { to: "/notifications" },
        current,
        className: railRowClass(current ? "current" : "none"),
        children: (
          <>
            <SiderailIcon icon={Bell} />
            <SiderailLabelClip collapsed={collapsed}>
              <span className="flex w-full items-center">
                <span className="truncate">Notifications</span>
                {badge ? (
                  <>
                    <span
                      aria-hidden="true"
                      data-unread-count={badge}
                      className={UNREAD_PILL}
                    >
                      {badge}
                    </span>
                    <span className="sr-only">{`, ${badge} unread`}</span>
                  </>
                ) : null}
              </span>
            </SiderailLabelClip>
          </>
        ),
      })}
    </SiderailTooltip>
  );
}
